<template>
  <div class="container-fluid">
    <div class="row" v-if="shouldShowAdvances">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-md-7 col-lg-5 col-xl-4 my-auto">
            <div class="d-flex flex-column flex-sm-row align-items-center justify-content-between">
              <div class="d-flex align-items-center mb-2 mb-sm-0">
                <span class="mr-2">Previous 6 months</span>
                <a
                  @click="showPrevSixMonths()"
                  role="button"
                  class="btn btn-hc"
                  data-target="#viewAllAdvances"
                  >&lt;&lt;</a
                >
              </div>
              <div class="d-flex align-items-center">
                <a
                  @click="showNextSixMonths()"
                  role="button"
                  class="btn btn-hc mr-2"
                  data-target="#viewAllAdvances"
                  :class="{ 'btn--disabled': disableButton }"
                  >&gt;&gt;</a
                >
                <span>Next 6 months</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-5 col-lg-4 offset-lg-1 mt-3 mt-md-0">
            <div class="form-group mb-0">
              <div class="d-flex flex-column flex-sm-row align-items-center">
                <span class="mr-2 mb-2 mb-sm-0">Choose time frame:</span>
                <b-form-select
                  v-model="selectedYear"
                  :options="years"
                  class="form-control"
                  name="selection"
                  required
                  @change="updateShownRange"
                ></b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hh_section mt-2">
      <div class="row mt-3">
        <div class="col-lg-8 fwfont">
          <template>
            <div class="h-100" v-if="shouldShowAdvances">
              <div class="row">
                <div
                  class="col-12 col-xl-6 px-2 mt-3"
                  v-for="(month, index) in lastSixMonths"
                  :key="index"
                >
                  <div class="border border-secondaryL h-100 p-3">
                    <half-hourly-advances-calander
                      v-model="selectedDay"
                      v-bind="HhMeterPoint"
                      :month="month"
                      select
                      @input="showAdvances(selectedDay)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="h-100" v-else>
              <img
                src="@/assets/img/warning_icon.png"
                class="img-fluid d-inline-block"
              />
              <p class="d-inline-block my-auto pl-2">
                No advances available at this time.
              </p>
            </div>
          </template>
        </div>
        <div
          id="advances_table_results_all"
          class="col-lg-4 mt-3 no-pad"
          v-if="shouldShowAdvances"
        >
          <advances-table :selectedDate="selectedDay" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import advancesMixin from "@/mixins/meterInfo/readings/advances.js";

import HalfHourlyAdvancesCalander from "../../meterPointSummary/components/HalfHourlyAdvancesCalander";
import advancesTable from "../../meterPointSummary/components/AdvancesView";

export default {
  name: "electricity-half-hourly-advances",
  mixins: [advancesMixin],
  components: {
    HalfHourlyAdvancesCalander,
    advancesTable,
  },
};
</script>

<style scoped>
.btn--disabled {
  background-color: rgb(220, 220, 200) !important;
  border-color: rgb(220, 220, 200) !important;
  box-shadow: inset 0 0 4px rgb(180, 180, 180);
}
</style>